<ngx-charts-line-chart
   #chart
   [curve]="curve"
   [legend]="legend"
   [legendPosition]="legendPosition"
   [maxXAxisTickLength]="maxXAxisTickLength"
   [maxYAxisTickLength]="maxYAxisTickLength"
   [referenceLines]="referenceLines"
   [results]="data"
   [rotateXAxisTicks]="rotateXAxisTicks"
   [scheme]="colorScheme"
   [showRefLabels]="!!referenceLines"
   [showRefLines]="!!referenceLines"
   [showXAxisLabel]="showXAxisLabel"
   [showYAxisLabel]="showYAxisLabel"
   [timeline]="timeline"
   [trimXAxisTicks]="trimXAxisTicks"
   [trimYAxisTicks]="trimYAxisTicks"
   [view]="view"
   [xAxis]="xAxis"
   [xAxisLabel]="xAxisLabel"
   [xAxisTickFormatting]="xAxisTickFormatting"
   [xScaleMin]="xScaleMin"
   [xScaleMax]="xScaleMax"
   [yAxis]="yAxis"
   [yAxisLabel]="yAxisLabel"
   [yAxisTickFormatting]="yAxisTickFormatting"
   (activate)="onActivate($event)"
   (deactivate)="onDeactivate($event)"
   (select)="onSelect($event)"
>
   @if (customTooltipTemplateRef; as model) {
   <ng-template #tooltipTemplate let-model="model">
      <ng-container *ngTemplateOutlet="customTooltipTemplateRef; context: { model: this.model }"></ng-container>
   </ng-template>
   } @if (customSeriesTooltipTemplateRef; as model) {
   <ng-template #seriesTooltipTemplate let-model="model">
      <ng-container *ngTemplateOutlet="customSeriesTooltipTemplateRef; context: { model: this.model }"></ng-container>
   </ng-template>
   }
</ngx-charts-line-chart>
<div style="clear: both"></div>
